import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as AO3AActions from '../../../ao-3a/ao-3a.actions';
import * as AppRootActions from '@app/app.actions';
import * as fromAppRoot from '@app/app.reducers';

@Component({
  selector: 'app-phone-verification',
  templateUrl: 'phone-verification.component.html',
  styleUrls: ['phone-verification.component.scss'],
  standalone: false
})
export class PhoneVerificationComponent implements OnDestroy, OnInit, AfterViewInit {
  protected readonly onDestroy$ = new Subject<void>();
  @ViewChild('verifyCodeInput') inputElement: ElementRef;
  @Input() phone: string;
  @Input() verified: boolean;
  @Output() updatePhoneVerification = new EventEmitter<boolean>();
  inputCode: string;
  phoneError = false;
  codeError = false;

  constructor(private store: Store) {
    this.store.pipe(select(fromAppRoot.selectSendCodeStatus), takeUntil(this.onDestroy$)).subscribe((data) => {
      this.phoneError = data.status === 'error';
    });
    this.store.pipe(select(fromAppRoot.selectVerifyCodeStatus), takeUntil(this.onDestroy$)).subscribe((data) => {
      if (!data.status) {
        return;
      }
      const success = data.status === 'success';
      this.codeError = !success;
      this.verified = success;
      this.updatePhoneVerification.emit(success);
      if (success) {
        this.store.dispatch(AO3AActions.fetchPersonalDetails());
      }
    });
  }

  ngOnInit(): void {
    if (!this.verified) {
      this.sendVerificationCode();
    }
  }

  ngAfterViewInit(): void {
    if (this.inputElement) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.inputElement.nativeElement.focus();
    }
  }

  inputUpdate(e: number): void {
    if (e === null || e === undefined) {
      return;
    }
    const event = e.toString().substring(0, 6);
    this.inputCode = event;
    if (event && event.length === 6) {
      this.verifyVerificationCode();
    }
    if (event.length > 0) {
      this.codeError = false;
    }
  }

  verifyVerificationCode(): void {
    this.store.dispatch(AppRootActions.verifyVerificationCode({ code: this.inputCode }));
    this.resetValues();
  }

  sendVerificationCode(): void {
    this.resetValues();
    this.store.dispatch(AppRootActions.sendVerificationCode());
  }

  resetValues(): void {
    this.phoneError = false;
    this.codeError = false;
    this.inputCode = null;
  }

  ngOnDestroy(): void {
    this.store.dispatch(AppRootActions.verifyCodeStatusReset());
    // TODO: fetchCustomer() - Let's align why do we have this here!
    this.store.dispatch(AppRootActions.fetchCustomer());
    // ---
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
